export default __webpack_public_path__ + "static/eWBkwbWN-fa435c591d73422bc832c4be8b7ef21e.svg";